import _ from 'lodash'
import slugify from 'slugify'
import { Product, User, Store } from 'src/declarations'


type RouteName<T> = {
    list?: string
    details?: (data: T) => string
}

export const productRoutes: RouteName<Product> = {
    list: '/vehicles',
    details: (product) => `/vehicles/${product.id}-${slugify(product.name)}`
}

export const userRoutes: RouteName<User> = {
    details: (user) => `/users/${user.id}-${slugify(user.firstName)}`
}

export const storeRoutes: RouteName<Store> = {
    details: (store) => `/stores/${store.id}-${slugify(store.name)}`
}